import { useNavigate, useSearchParams } from 'react-router-dom'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { MobileBottomLayout, FormSubmitButton, HelperWrapper } from 'src/components'

import useStyles from './styles'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

const MobileNewButtons = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const classes = useStyles()
  const [searchParams] = useSearchParams()
  const libraryDuplicate = searchParams.get('libraryDuplicate')

  const handleDiscard = () => navigate(joinAbsRoute(ROUTES.IMPACTS_LIBRARY))

  return (
    <MobileBottomLayout isFixed>
      <Button
        variant="contained"
        onClick={handleDiscard}
        className={`${classes.formButton} ${classes.formButtonLight}`}
      >
        <HelperWrapper t="discard-button-text" />
      </Button>
      <FormSubmitButton
        notDisabledIfDirty={!!libraryDuplicate}
        withoutIcon
        validText={t('save-button-text.v')}
        invalidText={t('save-button-text.v')}
      />
    </MobileBottomLayout>
  )
}

export { MobileNewButtons }
